import styled, { css } from 'styled-components'
import FormInputContainerBase from '../shared/styles/FormInputContainerBase.js'

export const NumberContainer = styled(FormInputContainerBase)`
	&>div {
		position: relative;
		width: 100%;
		max-width: 300px;
	}
	input[type=text] {
		text-align: right;

		-moz-appearance: textfield;
	    &::-webkit-inner-spin-button,
	    &::-webkit-outer-spin-button {
			-webkit-appearance: none;
			margin: 0;
	    }
	}
	${({ withControls }) => withControls && css`
		cursor: pointer;
		input[type=text] {
			padding-right: 24px;
			text-align: left;
		}
	`}
`

export const StepButton = styled.div`
	cursor: pointer;
	position: absolute;
    padding: 0 10px 18px 10px;
    display: inline-block;
    height: 18px;
    width: 26px;
    right: 0;
    z-index: 1;
    &::after {
		content: '';
		display: inline-block;
		width: 0;
		height: 0;
		border-style: solid;
	}
	${({ increment }) => increment && css`
		top: 0;
		&::after {
			border-color: transparent transparent #000;
			border-width: 2px 4px 4px;
		}
	`}
	${({ decrement }) => decrement && css`
		bottom: 0;
		&::after {
			border-color: #000 transparent transparent;
			border-width: 4px 4px 2px;
		}
	`}
`
